module.exports = new __parcel__URL__("pvp_game_divider.3cbdb7ce.png").toString();